import React from 'react'; 
import { Card, CardContent, CardHeader, Button, Typography } from "@material-ui/core";
import PropTypes from 'prop-types';
import { makeStyles } from "@material-ui/core/styles";
import "./css/contactCardComponent.css";
import { URL_CONSTANTS } from '../../../../data/constants';

const useStyles = makeStyles((theme) => ({
  button: {
    color: '#5aa8e8',
    border: '2px solid #5aa8e8',
    textTransform: 'none',
    fontSize: '1rem',
    width: '120px',
    backgroundColor: '#FFFFFF', 
    transition: 'background-color 0.3s',
    '&:hover': {
      backgroundColor: '#ebf2f5',
    },
  },
}));

const ContactCardComponent = ({ title, content, contact }) => {
  const classes = useStyles();
  return (
    <Card data-testid="contact-card" className="contact-card">
      <CardHeader
        title={
          <Typography variant="h6" data-testid="card-title">
            {title}
          </Typography>
        }
      />
      <CardContent>
        <div className="card-content">
          <div className="content-container"> 
            <Typography variant="body2" className="text-content" data-testid="card-content">
              {content}
            </Typography>
            <img
              src="/support.png"
              alt="Help"
              className="card-image"
              data-testid="card-image"
            />
          </div>
          <div>
            <Button
              className={classes.button}
              data-testid="contact-button"
              onClick={() => window.open(URL_CONSTANTS.CONTACT_BUTTON_URL, '_blank')}
            >
              {contact}
            </Button>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

ContactCardComponent.propTypes = {
  title: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
  contact: PropTypes.string.isRequired,
};

export default ContactCardComponent;
